<mat-table
  matSort
  [dataSource]="dataSource"
>
  <ng-container matColumnDef="number">
    <mat-header-cell *matHeaderCellDef mat-sort-header="number">
      {{ 'PHONE_NUMBER' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let element">{{ element.number | phoneNumber }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="action">
    <mat-header-cell *matHeaderCellDef></mat-header-cell>
    <mat-cell *matCellDef="let element" class="action-cell">
      <button
        mat-raised-button
        (click)="onChooseNumber(element)"
        color="primary-full"
        class="choose-button">
        <span translate>CHOOSE</span>
      </button>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>

<button
  *ngIf="showRefreshNumbersButton()"
  mat-raised-button
  (click)="onRefreshNumbers()"
  color="primary"
  class="refresh-button">
    <span class="material-icons refresh-icon">refresh</span>
    <span translate>ORDER_NUMBER.SHOW_MORE_NUMBERS</span>
</button>
